import { render, staticRenderFns } from "./gkrySchoolSearch.vue?vue&type=template&id=6bc2bd6e&"
import script from "./gkrySchoolSearch.vue?vue&type=script&lang=js&"
export * from "./gkrySchoolSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports